import Clock from '../../../clock/Clock';
import Weather from '../../../weather/Weather';
import AppPanel from '../../app-panel/AppPanel';
import LockScreen from '../../lock-screen/LockScreen';
import Styles from './HomeAndLockScreen.module.scss';
import classnames from "classnames";

interface HomeAndLockScreenProps {
    wallpaperLink?: string;
    customContainerClass?: string;
    isCheckingWallpapers?: boolean;
    onClickWallpapers?: () => void;
    onClickDone?: (type:string) => void;
}

const HomeAndLockScreen = ({ customContainerClass, wallpaperLink, isCheckingWallpapers = false, onClickWallpapers, onClickDone }: HomeAndLockScreenProps) => {
    return (
        <div className={classnames(Styles.screens_container, customContainerClass && customContainerClass)}>
            <div className={classnames(Styles.screen)}>
                <div className={classnames(Styles.actual_screen)}>
                    <div className={classnames(Styles.bg_holder, !wallpaperLink && Styles.lock)} style={wallpaperLink ? { background: `url("${wallpaperLink}")  no-repeat`, backgroundSize: "cover", backgroundPosition: "center" } : {}} />
                    <LockScreen isTransparentBg={!!wallpaperLink} />
                    <div className={Styles.screen_disabler} />
                    {isCheckingWallpapers && onClickDone && onClickWallpapers && <ActionButton type="lockscreen" onClickDone={onClickDone} onClickWallpapers={onClickWallpapers} />}
                </div>
            </div>
            <div className={classnames(Styles.screen)}>
                <div className={classnames(Styles.actual_screen)}>
                    <div className={classnames(Styles.bg_holder, !wallpaperLink && Styles.home)} style={wallpaperLink ? { background: `url("${wallpaperLink}")  no-repeat`, backgroundSize: "cover", backgroundPosition: "center" } : {}} />

                    <div className={Styles.widgets}>
                        <Weather />
                        <Clock />
                    </div>
                    <AppPanel />
                    <div className={Styles.screen_disabler} />
                    {isCheckingWallpapers && onClickDone && onClickWallpapers && <ActionButton type="background" onClickDone={onClickDone} onClickWallpapers={onClickWallpapers} />}
                </div>
            </div>
        </div>
    )
}

export default HomeAndLockScreen



interface ActionButtonProps {
    type:string
    onClickWallpapers: () => void;
    onClickDone: (type:string) => void;
}
const ActionButton = ({ type,onClickWallpapers, onClickDone }: ActionButtonProps) => {

    return (
        <div className={Styles.top_bar_buttons}>
            <div className={Styles.button} onClick={onClickWallpapers}>Wallpapers</div>
            <div className={Styles.button} onClick={()=>{onClickDone(type)}}>Done</div>
        </div>
    )
}